import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c(VBtn,{attrs:{"icon":""},on:{"click":_vm.converterEmbalagem}},[_c(VIcon,[_vm._v("mdi-repeat")])],1),_c('span',{staticClass:"font-13 font-weight-medium"},[_vm._v("Embalagem "+_vm._s((_vm.pedido_selecionado.emb_master === 'S') ? 'Master' : 'Mínima'))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }